// crm-web/frontend/src/hooks/useAnalyticsRange.js
// Hook para manejo de rango temporal del dashboard de analiticas.
// Persistencia en localStorage para que sobreviva reloads.

import { useState, useCallback } from 'react'

const STORAGE_KEY = 'analytics_range'

export const VALID_RANGES = ['today', 'yesterday', '7d', '30d', 'this_month', 'last_month']

export const RANGE_LABELS = {
  today: 'Hoy',
  yesterday: 'Ayer',
  '7d': 'Últimos 7 días',
  '30d': 'Últimos 30 días',
  this_month: 'Mes actual',
  last_month: 'Mes anterior',
}

function getInitialRange() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved && VALID_RANGES.includes(saved)) return saved
  } catch {
    // localStorage no disponible (ej. SSR o modo privado)
  }
  return '7d'
}

export default function useAnalyticsRange() {
  const [range, setRangeState] = useState(getInitialRange)

  const setRange = useCallback((newRange) => {
    if (!VALID_RANGES.includes(newRange)) return
    setRangeState(newRange)
    try {
      localStorage.setItem(STORAGE_KEY, newRange)
    } catch {
      // silencioso
    }
  }, [])

  return { range, setRange }
}
